<template>
    <div class="accordion" :id="`accordion-${data.id}`">
        <div class="card">
            <div class="card-header department-header" :id="`heading-${data.id}`" style="background-color: white;" :style="`padding-left: ${newOffset}px; border-bottom: 0px;`">
                <h2 class="mb-0">
                    <button class="btn btn-block text-left pr-0" type="button" data-toggle="collapse" aria-expanded="true">
                        <div class="flex">
                            <div class="w-2/3 xl:w-2/3 lg:w-3/4 pr-0 pl-0 selected-department" @click="chooseDepartment(data.id)">
                                <span :id="`department-text-${data.id}`">{{ name }}</span>
                            </div>
                            <div class="w-1/6 xl:w-1/6 lg:w-1/12 pl-0">
                                <i class="fas fa-times" @click="deleteDepartment(data.id, name)"></i>
                            </div>
                            <div class="w-1/6 xl:w-1/6 lg:w-1/12 pl-1 pr-0" v-if="data.children != null">
                                <i class="fas" :class="{ 'fa-chevron-left': !chevronOpened, 'fa-chevron-down': chevronOpened }" @click="clickDepartment(data.id)"></i>
                            </div>
                        </div>
                    </button>
                </h2>
            </div>

            <div v-if="data.children != null" :id="`collapse-${data.id}`" class="collapse" :aria-labelledby="`heading-${data.id}`" :data-parent="`#accordion-${data.id}`">
                <company-department v-for="(child, name) in data.children" v-bind:key="child.id" :data="child" :name="name" :offset="newOffset" v-on:change-department="changeDepartment" v-on:deleted-department="deleteDepartment"></company-department>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object,
            name: String,
            offset: Number,
            chevron: Boolean,
        },
        data: function () {
            return {
                newOffset: this.offset,
                chevronOpened: this.chevron,
                clickOpen: false,
                deleting: false
            }
        },
        beforeMount() {
            this.newOffset += 15;
        },
        methods: {
            /**
             *
             * Events
             *
             */
            clickDepartment(id) {
                this.clickOpen = true;
                this.chevronOpened = !this.chevronOpened;
                $(`#collapse-${id}`).collapse('toggle');
                $(`#department-text-${id}`).toggleClass('font-weight-bold');
            },
            chooseDepartment(departmentID) {
                if (!this.clickOpen && !this.delete) {
                    this.$emit('change-department', departmentID);
                }

                this.deleting = false;
                this.clickOpen = false;
            },
            changeDepartment(departmentID) {
                this.$emit('change-department', departmentID);
            },
            deleteDepartment(id, name) {
                this.deleting = true;
                this.$emit('deleted-department', id, name);
            },
        },
    }
</script>
